import React, { useState } from 'react';
import { Check, ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const ProductCard = ({ product, index }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Card
      className="overflow-hidden bg-white border-gray-200 hover-lift group"
      style={{
        animationDelay: `${index * 0.1}s`,
        opacity: 0,
        animation: 'fadeInUp 0.8s ease-out forwards'
      }}
    >
      <CardContent className="p-0">
        {/* Image Section */}
        <div className="relative h-80 overflow-hidden bg-gradient-to-br from-[#f7f5f2] to-[#e8e4df] flex items-center justify-center p-6">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1a1918]/80 via-transparent to-transparent pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <div className="text-[#d4af37] text-sm font-semibold mb-2">
              {product.tagline}
            </div>
            <h3 className="text-2xl font-bold text-white">{product.name}</h3>
          </div>
        </div>

        {/* Content Section */}
        <div className="p-6">
          <p className="text-[#736c64] mb-4 font-medium">{product.description}</p>
          
          {product.fullDescription && (
            <>
              <p className="text-[#736c64] text-sm mb-4 leading-relaxed">
                {product.fullDescription}
              </p>
              
              {/* Expandable Features */}
              {product.features && (
                <div className="mt-4">
                  <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="flex items-center justify-between w-full text-left font-semibold text-[#1a1918] mb-3 hover:text-[#d4af37] transition-colors"
                  >
                    <span>Key Features</span>
                    {isExpanded ? (
                      <ChevronUp className="w-5 h-5 text-[#d4af37]" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-[#d4af37]" />
                    )}
                  </button>
                  
                  {isExpanded && (
                    <div className="space-y-3 mb-6 animate-fadeInUp">
                      {product.features.map((feature, idx) => (
                        <div key={idx} className="flex items-start space-x-2">
                          <Check className="w-4 h-4 text-[#d4af37] mt-1 flex-shrink-0" />
                          <div>
                            <h4 className="text-sm font-semibold text-[#1a1918]">{feature.title}</h4>
                            <p className="text-xs text-[#736c64]">{feature.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </>
          )}

          <Button className="w-full border-2 border-[#d4af37] bg-transparent text-[#d4af37] hover:bg-[#d4af37] hover:text-white py-3 rounded-lg font-semibold transition-all duration-300">
            Inquire Now
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
